import {createContext} from "react";

export const Localize = createContext('es');